<template>
    <li>
        <schedule
            :record="project"
            :editable="is_administrator || is_db_admin_active || is_developer"
        />
    </li>
</template>

<script type="text/javascript">
import tab from "../mixins/Tab"

import Schedule from "./Schedule"

export default {
    mixins: [tab],
    components: {
        Schedule
    }
}
</script>
